import React, { Component } from 'react';
import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import LimiteCompraSelector from './LimiteCompraSelector.jsx';

class LimiteCompraLink extends Component {
    OpenPurchaseLimit() {
        $("#LimiteCompraSelector").modal();
    }

    render() {
        let tipoCuenta = this.props.data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.filter((c)=>c.Checked)
        let limiteMinimoPeso = tipoCuenta[0] ? tipoCuenta[0].LimiteMinimoCompraPeso : null;
        let limiteMinimoDolar = tipoCuenta[0] ? tipoCuenta[0].LimiteMinimoCompraDolar :null;
        let filtroMoneda = this.props.parametroGeneral.MONEDALIMITECOMPRA 
        let data = this.props.data.GET_LIMITE_COMPRA.filter(x => x.Id != 0);
        if(filtroMoneda=="P"){
            data = data.filter(y=> y.MonedaId == 1 && y.Valor >= limiteMinimoPeso)
        }else if(filtroMoneda=="D"){
            data = data.filter(y=> y.MonedaId != 1 && y.Valor >= limiteMinimoDolar)
        }else{
            data = this.props.data.GET_LIMITE_COMPRA.filter((x)=>{return ((x.MonedaId==1 && x.Valor>=limiteMinimoPeso) ||  (x.MonedaId!=1 && x.Valor>=limiteMinimoDolar))})
        }
        let errorSave = this.props.data.errorSave;
        if (data.find(x => x.Checked === true) !== undefined && errorSave) {
            errorSave = false;
        }
        
        return (
            data.length > 0 &&
            <div className="row top-separator-xs">
                <div className="col-md-3">
                    <label className="label-primary">Límite de Compra</label>
                    <br />
                    <GenericSimpleButton text="Seleccionar..." buttonType="button" buttonClass="btn btn-link no-padding" onClick={this.OpenPurchaseLimit} />
                    {errorSave === true ? <label className="error">Por favor selecciona al menos un limite</label> : undefined}
                    <GenericModal
                        type={"WITH_COMPONENTS_SAVE_CANCEL_MD"}
                        className="modal fade-out" id="LimiteCompraSelector"
                        header="Límites"
                        component={
                            <LimiteCompraSelector
                                data={data}
                                edicion={this.props.data.edicion}
                                saveSelectedLimiteCompra={this.props.saveSelectedPurchaseLimits}
                                cancelSelectedLimiteCompra={this.props.cancelSelectedPurchaseLimits}
                            />}
                    />
                    
                </div>
            </div>
        );
    }
};

export default LimiteCompraLink;


                    